import { render, staticRenderFns } from "./IconMedicationSafety.vue?vue&type=template&id=63c5a89a&"
import script from "./IconMedicationSafety.vue?vue&type=script&lang=js&"
export * from "./IconMedicationSafety.vue?vue&type=script&lang=js&"
import style0 from "./IconMedicationSafety.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports